import { LOCAL_STORAGE_KEYS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class AppTrainingVideoHTMLManager {
  async saveAppTrainingVideoHTML(appTrainingVideoHTML) {
    try {
      await PBStorage.set(
        LOCAL_STORAGE_KEYS.APP_TRAINING_VIDEO_HTML,
        appTrainingVideoHTML,
      );
    } catch (e) {
      console.log('saveAppTrainingVideoHtml failed', e);
      return null;
    }
  }

  async getAppTrainingVideoHTML() {
    try {
      let appTrainingVideoHTML =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.APP_TRAINING_VIDEO_HTML)) ||
        null;

      return appTrainingVideoHTML;
    } catch (e) {
      console.log('getAppTrainingVideoHtml fail', e);
    }
  }
}

export default new AppTrainingVideoHTMLManager();
